import { render, staticRenderFns } from "./AnimatedLogo.vue?vue&type=template&id=13b6f6cc"
import script from "./AnimatedLogo.vue?vue&type=script&lang=js"
export * from "./AnimatedLogo.vue?vue&type=script&lang=js"
import style0 from "./AnimatedLogo.vue?vue&type=style&index=0&id=13b6f6cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports